import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Contact from '../components/Contact/Contact';

const PageContainer = styled.main`
  padding-top: 80px;
`;

const PageBanner = styled.div`
  height: 300px;
  background-color: ${props => props.theme.colors.darkGray};
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
`;

const BannerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: linear-gradient(
    to bottom right,
    ${props => props.theme.colors.darkGray},
    ${props => props.theme.colors.black}
  );
  opacity: 0.8;
`;

const PageTitle = styled(motion.h1)`
  color: ${props => props.theme.colors.white};
  text-align: center;
  position: relative;
  z-index: 2;
  font-size: 3rem;
`;

const ContactPage = () => {
  return (
    <PageContainer>
      <PageBanner>
        <BannerOverlay />
        <PageTitle
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
        >
          Contact AI AUTOMATION
        </PageTitle>
      </PageBanner>
      <Contact />
    </PageContainer>
  );
};

export default ContactPage; 